import { StoreState } from '@shared/models/interfaces/store'
import { Nullable } from '@shared/models/types/primary'

import { Pagination } from '@protos/response/pagination_pb'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getInitialState<T>(initialData: any = null): StoreState<T> {
  return {
    data: initialData,
    status: {
      pending: false,
      success: false,
      fail: false,
      error: null,
    },
  }
}

// use just with proto-ts
export function updateStateData<
  T extends { data: Array<M>; meta?: Pagination },
  M,
>(stateList: Array<M> = [], additionalData: T, isResetable = false): T {
  const updatedList = [...stateList, ...additionalData.data]
  const updatedData = {
    data: updatedList,
    meta: additionalData.meta,
  } as T

  if (isResetable || additionalData.meta?.page === 1) {
    return additionalData
  }

  return updatedData
}

export function _mutationPending<T>(state: StoreState<T>) {
  return {
    data: state.data,
    status: {
      success: false,
      fail: false,
      error: null,
      pending: true,
    },
  }
}

export function _mutationSuccess<T>(data: T) {
  return {
    data,
    status: {
      pending: false,
      success: true,
      fail: false,
      error: null,
    },
  }
}

export function _mutationFail(error: unknown) {
  return {
    data: null,
    status: {
      pending: false,
      success: false,
      fail: true,
      error,
    },
  }
}

export function _mutationFailSaveState<T>(
  state: StoreState<T>,
  error: unknown
) {
  return {
    data: state.data,
    status: {
      pending: false,
      success: false,
      fail: true,
      error,
    },
  }
}

export function updateState<T>(
  state: StoreState<T>,
  data: Nullable<T | Error> = null,
  saveStateData?: boolean
) {
  if (data === null) {
    // When request is pending
    return _mutationPending<T>({ ...state })
  }

  if (data instanceof Error && saveStateData) {
    return _mutationFailSaveState<T>(state, data)
  }

  // When request is succeeded / failed
  return data instanceof Error ? _mutationFail(data) : _mutationSuccess(data)
}
